import { render } from "./ConsultingDetailClient.vue?vue&type=template&id=55434a6a"
import script from "./ConsultingDetailClient.vue?vue&type=script&lang=js"
export * from "./ConsultingDetailClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__